import React, { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { baseUrl } from "../Univ.js";

function PharmPoList() {

    const [poData, setPoData] = useState([]);

    useEffect(() => {
        fetchPOData();
    }, []);

    const fetchPOData = () => {

        axios
            .get(`${baseUrl}pharm-purchase-order/`)
            .then((response) => {

                const transformed = response.data.map((item) => ({

                    id: item.id,
                    po_no: item.po_no,
                    po_date: item.add_date,
                    vendor: item.vendor?.name,
                    rfq_no: item.rfq?.rfq_no,
                    total_amount: item.total_amount,
                    status: item.status,

                }));

                setPoData(transformed);

            })
            .catch((error) => {
                console.log(error);
            });

    };

    const columns = [

        {
            field: "id",
            headerName: "ID",
            width: 80
        },

        {
            field: "po_no",
            headerName: "PO No",
            width: 180
        },

        {
            field: "po_date",
            headerName: "PO Date",
            width: 150
        },

        {
            field: "rfq_no",
            headerName: "RFQ No",
            width: 150
        },

        {
            field: "vendor",
            headerName: "Vendor",
            width: 220
        },

        {
            field: "total_amount",
            headerName: "Total Amount",
            width: 160
        },

        {
            field: "status",
            headerName: "Status",
            width: 140,
            renderCell: (params) => (
                <span
                    className={
                        params.value === "Open"
                            ? "badge bg-success"
                            : "badge bg-secondary"
                    }
                >
                    {params.value}
                </span>
            )
        },

        {
            field: "action",
            headerName: "Action",
            width: 250,
            sortable: false,
            filterable: false,
            renderCell: (params) => (

                <div className="d-flex gap-2">

                    <Link
                        to={`/pharm-po-view/${params.row.id}`}
                        className="btn btn-success btn-sm"
                    >
                        View
                    </Link>

                    <Link
                        to={`/pharm-po-grn-entry/${params.row.id}/`}
                        className="btn btn-primary btn-sm"
                    >
                        Po to GRN
                    </Link>

                </div>

            )
        }

    ];

    return (

        <section className="container-fluid mt-3">

            <h3
                className="text-center mb-3"
                style={{
                    backgroundColor: "#e5eaef",
                    padding: "10px"
                }}
            >
                Purchase Order List
            </h3>

            <DataGrid
                rows={poData}
                columns={columns}
                pageSize={10}
                autoHeight
                slots={{ toolbar: GridToolbar }}
                sx={{
                    boxShadow: 4,
                    border: 2,
                    borderColor: "primary.light",
                    "& .MuiDataGrid-cell:hover": {
                        color: "primary.main"
                    }
                }}
            />

        </section>

    );
}

export default PharmPoList;